// extracted by mini-css-extract-plugin
module.exports = {"popper":"popper-27Jo6","container":"container-10ZYV","tooltip":"tooltip-1frBr","tooltip_recommend":"tooltip_recommend-1nM5D","tooltip_withInfo":"tooltip_withInfo-3ChJ1"};